import Select from "react-select";
import type { GPGamePlayerResponse } from "../../../types";

interface PlayerOption {
	value: number;
	label: string;
}

interface PlayerModalPlayerSelectProps {
	label: string;
	placeholder: string;
	players: GPGamePlayerResponse[];
	onPlayerChange: (playerId: number, playerName: string) => void;
}

function isSelectablePlayer(player: GPGamePlayerResponse): player is GPGamePlayerResponse & { id: number; name: string } {
	return player.id != null && player.name !== null && player.name !== "";
}

export function PlayerModalPlayerSelect({ label, placeholder, players, onPlayerChange }: PlayerModalPlayerSelectProps) {
	const playersOptions: PlayerOption[] = players.filter(isSelectablePlayer).map((player) => ({
		value: player.id,
		label: player.name,
	}));

	if (playersOptions.length === 0) {
		return null;
	}

	return (
		<div className="playerRatingModal-players">
			<label htmlFor="player-select">{label}</label>
			<Select
				id="player-select"
				options={playersOptions}
				onChange={(option) => onPlayerChange(option?.value ?? 0, option?.label ?? "")}
				className="player-select"
				placeholder={placeholder}
			/>
		</div>
	);
}
